module.exports = __webpack_public_path__ + "img/box6-21.52029629.png";